<template>
  <section class="section pt-0">
    <div class="columns">
      <div class="column">
        <products-datatable @selected="add_product" />
      </div>
      <div
        class="column is-one-third"
        v-bind:class="{
          'is-hidden':
            module_settings && module_settings.show_shopping_cart == false,
        }"
      >
        <shopping-cart
          ref="shopping_cart"
          @pay="payment"
          :module_settings="module_settings"
          @visanet_payment="visanet_payment"
        />
      </div>
    </div>
    <payment-modal
      :module_settings="module_settings"
      ref="payment_modal"
      @success="payment_success"
      @visanet_payment="visanet_payment"
    />
  </section>
</template>

<script>
import { get_configuration } from "@/utils";
import ProductsDatatable from "./products_datatable/Index.vue";
import ShoppingCart from "./shopping_cart/Index.vue";
import PaymentModal from "./payment_modal/Index.vue";

export default {
  name: "PointOfSaleIndex",
  components: {
    ProductsDatatable,
    ShoppingCart,
    PaymentModal,
  },
  data() {
    return {
      module_settings: {},
    };
  },
  methods: {
    add_product(product) {
      this.$refs.shopping_cart.add_product(product);
    },
    payment(products_data) {
      this.$refs.payment_modal.show_modal(products_data);
    },
    payment_success() {
      this.$refs.shopping_cart.clear();
    },
    visanet_payment(amount) {
      this.$refs.visanet_payment_modal.show_modal(amount);
    },
  },
  mounted() {},
  created() {
    let v = this;
    get_configuration(this)
      .then((conf) => {
        v.module_settings = conf;
      })
      .catch((error) => {
        console.error(error);
      });
  },
};
</script>

<style scoped></style>
